var map = {
	"./arrow-new.svg": "7dad",
	"./arrow.svg": "1106",
	"./facebook-d.svg": "6f4e",
	"./facebook-l.svg": "2fb1",
	"./instagram-d.svg": "5222",
	"./instagram-l.svg": "f7a8",
	"./linkedin-d.svg": "6fa5",
	"./linkedin-l.svg": "d2b4",
	"./logo_DT.svg": "fe60",
	"./planet-logo.svg": "3d8d",
	"./twitter-d.svg": "8a40",
	"./twitter-l.svg": "4fc1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";